<template>
  <div class="search-base search-container">
    <search-filter-item
      v-if="layout === 'filter'"
      ref="searchFilterItem"
      :label="label"
      @remove="onClickFilterRemove"
    >
      <div class="flex items-center gap-2">
        <date-selector v-model="date" :readonly="readonly" :placeholder="$t('선택')" @change="onChangeData" class="flex-1" />
      </div>
    </search-filter-item>
    <search-label-body v-else :label="label" :label-hidden="!label" :columns="gridTemplateColumns">
      <div class="flex-1 flex flex-wrap items-center gap-2">
        <date-selector v-model="date" :readonly="readonly" :placeholder="$t('선택')" @change="onChangeData" class="w-full xl:w-128px" />
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import moment from "moment";
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import SearchFilterItem from "@/views/list/components/base/SearchFilterItem.vue";

export default {
  name: "SearchDate",
  components: {
    SearchFilterItem,
    SearchLabelBody,
    DateSelector,
    SearchNavItemSelect,
  },
  props: {
    label: {
      default: "대상기간",
      type: String,
    },
    value: [String, Object],
    setRef: Function,
    readonly: Boolean,
    query: {
      type: Object,
      default: () => {
        return {
          sd: "",
        };
      },
    },
    options: Object,
  },
  computed: {
    layout() {
      return this.options && this.options.layout ? this.options.layout : 'default';
    },
    isMobile() {
      return !(this.$store.state.verticalNavMenuWidth === "default");
    },
    initData() {
      const defaultValue = this.options && this.options["default"] ? this.options["default"] : '';
      const _query_keys = Object.keys(this.query);
      const query = this.$route.query;
      const sd = query[_query_keys];
      const data = sd || defaultValue;
      return data;
    },
    gridTemplateColumns() {
      return this.options && this.options.gridTemplateColumns ? this.options.gridTemplateColumns : 'auto auto';
    },
  },
  watch: {
    value(value) {
      this.date = value;
    },
  },
  data() {
    return {
      date: "",
    };
  },
  created() {
    this.date = this.initData;
    this.$emit("input", this.date);
  },
  mounted() {
    if (this.setRef) {
      // filter 모드에서 초기화 버튼 클릭시 검색조건을 초기화 하기 위해서 ref 를 연결해주기 위함
      this.setRef('searchFilterItem', this.$refs.searchFilterItem)
    }
  },
  methods: {
    onChangeData() {
      this.$emit("input", this.date);
      this.$emit("change", this.date);

      this.$emit("onSearch");
    },
    onClickFilterRemove () {
      this.date = "";
      this.onChangeData();
    }
  },
};
</script>
